import { render, staticRenderFns } from "./index.vue?vue&type=template&id=367c502f&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=367c502f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367c502f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('367c502f')) {
      api.createRecord('367c502f', component.options)
    } else {
      api.reload('367c502f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=367c502f&scoped=true&", function () {
      api.rerender('367c502f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/stat/custServiceDept/index.vue"
export default component.exports